import { useTranslation } from 'react-i18next';
import {
  MonthFilterField,
  fromMonthValue,
  toMonthValue,
} from '../../../shared/components/MonthFilterField';

export interface MesAnoFilterProps {
  mes: number;
  ano: number;
  onChange: (next: { mes: number; ano: number }) => void;
  disabled?: boolean;
}

/** Competência de um mês fechado, no mesmo campo das listagens. */
export function MesAnoFilter({ mes, ano, onChange, disabled }: MesAnoFilterProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <MonthFilterField
      label={t('components.monthFilter.competencia')}
      value={toMonthValue(ano, mes)}
      onChange={(value) => {
        const parsed = fromMonthValue(value);
        if (parsed.year == null || parsed.month == null) return;
        onChange({ mes: parsed.month, ano: parsed.year });
      }}
      disabled={disabled}
    />
  );
}
